import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ab223cb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
import moment from "moment";
import { reactive, watch, ref, unref, onMounted, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { updateState, todoListPage } from "@/api/deviceManage";
const __default__ = {
  name: "todoList"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    let startTime = moment().format('YYYY-MM-DD') + " 00:00:00";
    let endTime = moment().format('YYYY-MM-DD') + " 23:59:59";
    const route = useRoute();

    // 表格标题
    const tableTitle = computed(() => {
      return '待办事宜';
    });
    const state = reactive({
      tableData: {
        rows: [],
        total: 0
      }
    });
    let queryParams = reactive({
      pageNum: 1,
      pageSize: 10,
      actNum: "",
      areaId: "",
      valveName: "",
      wellNum: ""
    });
    const searchFormData = ref([{
      prop: "actNum",
      label: "执行器编号",
      placeholder: "请输入执行器编号",
      type: "text",
      span: 4
    }]);
    let loading = ref(false);
    const closeApply = () => {
      state.dialogVisible = false;
    };
    const getList = () => {
      loading.value = true;
      todoListPage(queryParams).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const resetQuery = () => {
      queryParams.pageNum = 1;
      queryParams.pageSize = 10;
      queryParams.actNum = "";
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      class: "btn-liquid",
      icon: "el-icon-search",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "actNum",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "location",
      label: "设备位置",
      fixed: false,
      type: "text"
    }, {
      prop: "opStartTime",
      label: "执行开始时间",
      fixed: false,
      type: "text"
    }, {
      prop: "opEndTime",
      label: "执行结束时间",
      fixed: false,
      type: "text"
    }, {
      prop: "applyUser",
      label: "申请人",
      fixed: false,
      type: "text"
    }, {
      prop: "applyReason",
      label: "申请事由",
      fixed: false,
      type: "text"
    }, {
      prop: "applyTime",
      label: "申请时间",
      fixed: false,
      type: "text"
    }, {
      prop: "auditUser",
      label: "审核人",
      fixed: false,
      type: "text"
    }];
    onMounted(async () => {});
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_commonTable = _resolveComponent("commonTable");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-daichulidingdan",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])])]);
    };
  }
});